import React, { Component } from 'react';
import { Breadcrumb, Tabs, Button, Form, Input, Radio, DatePicker, message, Select, Modal } from 'antd';
import { Link } from "react-router-dom";
import './index.less';
import ImgPreview from 'CMPT/common/ImgPreview';
import UploadVoucher from './uploadVoucher';
import { API } from '@/http/api';
import http from '@/http';
import userUtil from "@/utils/user";
import moment from "moment";
import debounce from 'lodash/debounce';
import Table from "CMPT/common/Table";
const { RangePicker } = DatePicker;
const BreadcrumbItem = Breadcrumb.Item;
const { TabPane } = Tabs;
const { Search, TextArea } = Input;

const Option = Select.Option
const RadioGroup = Radio.Group
class UserOrder extends Component {

    state = {
        keyword: '',
        companyName: '',
        columns: [
            {
                title: "姓名",
                key: "userName",
                align: "center",
                dataIndex: "userName",
            },
            {
                title: "手机号码",
                key: "userMobile",
                align: "center",
                dataIndex: "userMobile",
            },
            {
                title: "企业名称",
                key: "organizationName",
                align: "center",
                dataIndex: "organizationName",
                
            },
            {
                title: "查询时间", // 0 表示待审核状态
                key: "createDate",
                align: "center",
                dataIndex: "createDate",
                render: (text, record) => {
                    return (
                        <span>{text ? moment(text).format("YYYY-MM-DD HH:mm") : "-"}</span>
                    );
                },
            },
            {
                title: "查询车辆",
                key: "plate",
                align: "center",
                dataIndex: "plate",
            },
            {
                title: "查询类型",
                key: "trackQueryType",
                align: "center",
                dataIndex: "trackQueryType",
                render: (text, record) => {
                    return (
                        <span>{text == 0 ? '定位查询' : "轨迹查询"}</span>
                    );
                },
            },
            {
                title: "使用次数",
                key: "requestNumber",
                align: "center",
                dataIndex: "requestNumber",
            },
            
            {
                title: "查询状态",
                key: "queryStatus",
                align: "center",
                dataIndex: "queryStatus",
                render: (text, record) => {
                    return (
                        <span>{text == 0 ? '失败' : "成功"}</span>
                    );
                },
            },
            {
                title: "失败原因",
                key: "failReason",
                align: "center",
                dataIndex: "failReason",
            },
            // {
            //   title: "付款凭证",
            //   key: "payPhotos",
            //   align: "center",
            //   dataIndex: "payPhotos",
            //     render: (text) => {
            //     return text ? <div className='img_show_btn' onClick={() => this.imgShow(text)}><span>
            //         <i className='iconfont icon-zukehetong'></i>
            //         共{text.length}张
            //     </span></div> : '-';
            //   },
            // },
            // {
            //     title: "状态",
            //     key: "stateName",
            //     align: "center",
            //     dataIndex: "stateName",
            // },
            // {
            //     title: "操作",
            //     key: "code",
            //     align: "center",
            //     dataIndex: "code",
            //     render: (text, record) => {
            //         if (record.stateName) {
            //             if (record.stateName == '账期待付款') {
            //                 return <div className='oprate img_show_btn' 
            //                 onClick={() => {
            //                     this.setState({
            //                         payMoneyVoucherModal: true,
            //                         upVCode: record.code
            //                     })
            //                 }}>
            //                   <span>上传凭证</span>
            //               </div>
            //             } else if (record.stateName == '待审核') {
            //                 return <>
            //                 <div className='oprate' >
            //                     <span className='agree' onClick={() => this.auditDepositModal('10', record.code)}>通过</span>
            //                     <span className='reject_btn' onClick={() => {this.auditDepositModal('20', record.code)}}>驳回</span>
            //                 </div>
            //               </>
            //             } else if (record.stateName == '成功' || record.stateName == '失败') {
            //                 return <div className='oprate' onClick={() => this.goRecord(record.code)}>操作记录</div>
            //             }
            //         }
            //     },
            // },
        ],
        params: {
            pageSize: 10,
            pageNo: 1,
        },
        addRecordList: [],
        currentIndex: 0,
        payMoneyVoucherModal: false,
        upVCode: '',
        sourceList: [],
        supplierArray: [
            {
                key: 0,
                value: "失败"
            },
            {
                key: 1,
                value: "成功"
            },
        ],
        trackQueryArray: [
            {
                key: 0,
                value: "定位查询"
            },
            {
                key: 1,
                value: "轨迹查询"
            },
        ],
    }

    componentDidMount() {
        this.auditList()
        // this.getSourceList()
    }

    auditDepositModal = (auditStatus, code) => {
        if (auditStatus == '10') {
            Modal.confirm({
                title: '提示',
                icon: 'none',
                content: <div className='confirm_text'>
                    <div className='confirm_1'>确定已收到款吗？</div>
                    <div className='confirm_2'>说明：确定后将自动为该用户充值</div>
                </div>,
                onOk: () => {
                    this.auditDeposit(code, auditStatus)
                }
            })
        } else {
            Modal.confirm({
                title: '提示',
                icon: 'none',
                content: <div>
                    <TextArea
                        rows={4}
                        onChange={this.onRejectInput}
                        placeholder="请输入驳回理由 （100字以内）"
                        maxLength={100}
                    />
                    <span>说明：驳回后用户可重新发起订单付款</span>
                </div>,
                onOk: () => {
                    this.auditDeposit(code, auditStatus)
                }
            })
        }
    }
    onRejectInput = (e) => {
        this.state.auditRemark = e.target.value;
    };

    goRecord = (code) => {
        this.props.history.push(`/app/crm/valueaddService/trajectoryFind/operaterRecord/${code}`)
    }

    auditDeposit = (code, auditStatus) => {
        const config = {
            api: API.valueAddServiceAuditDeposit,
            showLoading: true,
            data: {
                code,
                auditStatus
            }
        };
        let { auditRemark } = this.state;
        if (auditStatus == '20') {
            config.data.auditRemark = auditRemark;
        }
        http(config).then(res => {
            if (res.code == 200) {
                message.success('操作成功')
                this.auditList()
            }
        })
    }

    getSourceList = () => {
        const config = {
            api: API.valueAddServiceGetSourceList,
            showLoading: true,
        };
        http(config).then(res => {
            if (res.code == 200) {
                this.setState({
                    sourceList: res.data
                })
            }
        })
    }

    imgShow = (list) => {
        let imgList = list.map(item => {
            return item.url
        })
        this.setState({
            imgList,
            previewVisible: true
        })
    }
    closeImagePreview = () => {
        this.setState({
            previewVisible: false
        })
    }


    auditList = () => {
        let { params } = this.state;
        const config = {
            api: API.valueAddServiceCrmUsedRecordsList,
            showLoading: true,
            data: params
        };
        http(config).then(res => {
            if (res.code == 200) {
                res.result.total = Number(res.result.total)
                this.setState({
                    addRecordList: res.result
                })
            }
        })
    }

    rangeChange = (value, date) => {
        let params = this.state.params;
        params.startDate = date[0];
        params.endDate = date[1];
        this.setState({
            params,
            startDate: value[0],
            endDate: value[1]
        }, () => {
            this.auditList();
        })
    }

    changeSource = (e) => {
        let params = this.state.params;
        params.tenantCode = e;
        this.setState({
            params,
        }, () => {
            this.auditList();
        })
    }

    changeSupplier = (e) => {
        let params = this.state.params;
        params.queryStatus = e;
        this.setState({
            params,
        }, () => {
            this.auditList();
        })
    }
    queryStatusSearch = (e) => {
        console.log(e);
        let params = this.state.params;
        params.queryStatus = e;
        this.setState({
            params,
        }, () => {
            this.auditList();
        })
    }
    changetrackQueryType = (e) => {
        let params = this.state.params;
        params.trackQueryType = e;
        this.setState({
            params,
        }, () => {
            this.auditList();
        })
    }
    trackQueryTypeSearch = (e) => {
        console.log(e);
        let params = this.state.params;
        params.trackQueryType = e;
        this.setState({
            params,
        }, () => {
            this.auditList();
        })
    }
    searchChange = (e) => {
        this.setState({
            keyword: e.target.value
        })
    }
    onSearchOn = (e) => {
        let { params } = this.state;
        params.keyword = e;
        this.setState({
            params
        }, () => {
            this.auditList()
        })
    }
    companyNameChange = (e) => {
        this.setState({
            companyName: e.target.value
        })
    }
    onCompanyNameOn = (e) => {
        let { params } = this.state;
        params.companyName = e;
        this.setState({
            params
        }, () => {
            this.auditList()
        })
    }


    resetSearch = () => {
        let { params } = this.state;
        params.keyword = '';
        params.startDate = '';
        params.endDate = '';
        params.tenantCode = undefined;
        params.queryStatus = undefined;
        params.trackQueryType = undefined;

        this.setState({
            params,
            startDate: undefined,
            endDate: undefined,
            keyword: '',
            companyName: '',
        }, () => {
            this.auditList()
        })
    }

    payMoneyVoucherModalOk = (payPhotos) => {
        console.log(payPhotos, 'payPhotos');
        let { upVCode } = this.state;
        const config = {
            api: API.valueAddServiceDepositUpload,
            showLoading: true,
            data: {
                code: upVCode,
                payPhotos
            }
        };
        http(config).then(res => {
            if (res.code == 200) {
                message.success('上传成功');
                this.setState({
                    payMoneyVoucherModal: false
                })
                this.auditList()
            }
        })
    }

    payMoneyVoucherModalCancel = () => {
        this.setState({
            payMoneyVoucherModal: false
        })
    }

    //分页
    onChangePage = (pageNo, pageSize, sort) => {
        this.setState(
            {
                params: {
                    ...this.state.params,
                    pageNo: pageNo,
                    pageSize: pageSize,
                },
            },
            () => {
                this.auditList();
            }
        );
    };


    render() {
        const { keyword, companyName, params, addRecordList, columns, previewVisible, currentIndex, imgList, startDate, endDate, payMoneyVoucherModal, sourceList, supplierArray, trackQueryArray } = this.state;
        const { getFieldDecorator } = this.props.form;
        return (

            <div className="enterprise-auth-con-1">
                {/* <div className='enterprise-auth-header'>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link
                                style={{ color: "#333" }}
                                to={{
                                    pathname: "/app/crm/valueaddService/trajectoryFind",
                                }}
                            >
                                数据概览
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>添加记录</Breadcrumb.Item>
                    </Breadcrumb>
                </div> */}
                <div className='tab_box'>
                    {/* <Tabs defaultActiveKey="0" className='tabs' style={{margin: 0}} onChange={this.changeTabs} >
                        <TabPane tab="全部"  key="0" className='tab'>
                        </TabPane>
                        <TabPane tab="待审批"  key="1" className='tab'>
                        </TabPane>
                        <TabPane tab="已成功"  key="2" className='tab'>
                        </TabPane>
                        <TabPane tab="账期待付款"  key="4" className='tab'>
                        </TabPane>
                        <TabPane tab="已失败"  key="3" className='tab'>
                        </TabPane>
                    </Tabs> */}

                    <div className='table_box' style={{ paddingTop: '24px' }}>
                        <div className="goods_fliter">
                            <RangePicker value={[startDate, endDate]} onChange={this.rangeChange} style={{ marginRight: '12px' }} />
                            <Select allowClear showSearch optionFilterProp="label" value={params.queryStatus} onChange={this.changeSupplier} onSearch={this.queryStatusSearch}
                                placeholder="状态" style={{ width: '100px', display: 'inline-block' }}>
                                {supplierArray.map(item => (
                                    <Option key={item.key} value={item.key} label={item.value}>
                                        <span>{item.value}</span>
                                    </Option>
                                ))}
                            </Select>
                            <Select allowClear showSearch optionFilterProp="label" value={params.trackQueryType} onChange={this.changetrackQueryType} onSearch={this.trackQueryTypeSearch}
                                placeholder="查询类型" style={{ width: '100px', display: 'inline-block' }}>
                                {trackQueryArray.map(item => (
                                    <Option key={item.key} value={item.key} label={item.value}>
                                        <span>{item.value}</span>
                                    </Option>
                                ))}
                            </Select>
                            {/* <Search
                                placeholder="企业统一信用代码/企业名称"
                                className="goods_search nomargin"
                                value={companyName}
                                // size="large"
                                onChange={value => { this.companyNameChange(value) }}
                                onSearch={value => { this.onCompanyNameOn(value) }}
                            /> */}
                            <Search
                                style={{marginLeft:'10px'}}
                                placeholder="姓名/手机号码/企业名称/车牌号"
                                enterButton="搜索"
                                className="goods_search nomargin"
                                value={keyword}
                                // size="large"
                                onChange={value => { this.searchChange(value) }}
                                onSearch={value => { this.onSearchOn(value) }}
                            />
                            <span className="goods_reset" onClick={this.resetSearch}>重置</span>
                        </div>
                        <Table
                            columns={columns}
                            selfProcessData={addRecordList && addRecordList.records}
                            total={addRecordList && addRecordList.total}
                            change={this.onChangePage}
                            current={addRecordList && addRecordList.current}
                        />
                    </div>
                </div>

            </div>

        );
    }
}

const UserTOrder = Form.create({ name: "UserOrder" })(UserOrder);
export default UserTOrder;